import { FOCUSABLES_SELECTOR, isElementFocusable } from './is-focusable';

let modalIndex = 100;
export default function toggleElement( elementOrId, show, focus ) {
	if ( ! elementOrId ) {
		return;
	}

	let target, targetId;
	if ( typeof elementOrId === 'string' ) {
		targetId = elementOrId;
		target = document.getElementById( targetId );
	} else {
		target = elementOrId;
		targetId = target.id;
	}

	if ( ! target ) {
		return;
	}

	// Get the controls for this element
	const controls = document.querySelectorAll( `[aria-controls="${ targetId }"]` );

	if ( typeof show === 'undefined' || show === null ) {
		// Toggle based on target's hidden status
		show = target.getAttribute( 'aria-hidden' ) === 'true';
	}

	// Update the controls if applicable
	controls.forEach( control => {
		if ( control.hasAttribute( 'aria-expanded' ) ) {
			control.setAttribute( 'aria-expanded', show );
		}
		if ( control.hasAttribute( 'aria-selected' ) ) {
			control.tabIndex = show ? null : -1;
			control.setAttribute( 'aria-selected', show );
		}
	} );

	// Hide/show the target
	target.setAttribute( 'aria-hidden', ! show );
	if ( show && focus ) {
		if ( target.getAttribute( 'role' ) === 'dialog' ) {
			// If it's a modal, update the z-index to the next level up
			target.style.zIndex = ++modalIndex;

			if ( target.classList.contains( 'js-minimodal' ) ) {
				const rects = target.getClientRects();
				if ( rects.length > 0 ) {
					if ( ! target.classList.contains( 'anchor-right' ) && rects[ 0 ].left + rects[ 0 ].width > window.innerWidth ) {
						target.classList.add( 'anchor-right' );
					}
					if ( rects[ 0 ].top + rects[ 0 ].height > window.innerHeight ) {
						target.classList.add( 'anchor-bottom' );
						target.style.setProperty( '--max-height', window.innerHeight - rects[ 0 ].top + 'px' );
					} else {
						target.classList.remove( 'anchor-bottom' );
						target.style.setProperty( '--max-height', window.innerHeight - rects[ 0 ].top + 'px');
					}
				}
			}
		}

		const autofocus = [ ...target.querySelectorAll( '[autofocus]' ) ].find( isElementFocusable );

		// If target contains an autofocus element, focus that
		if ( autofocus ) {
			autofocus.focus();

			// If target itself is meant to be focused (is tabble or has explicit tabindex)
		} else if ( target.tabIndex > 0 || target.hasAttribute( 'tabindex' ) ) {
			target.focus( { preventScroll: true } );
		} else {
			// Find the first focusable element within and focus that
			const focusable = [ ...target.querySelectorAll( FOCUSABLES_SELECTOR ) ].find( isElementFocusable );
			if ( focusable ) {
				focusable.focus();
			}
		}
	}

	// Trigger event for target ID
	const event = new CustomEvent( `toggle-${ show ? 'on' : 'off' }` );
	target.dispatchEvent( event );

	// Toggle class on body
	document.body.classList.toggle( `showing-${ targetId }`, show );

	return show;
}
